import styled from 'styled-components'

export const RegisteredTrademarkIconWrapper = styled.span`
  font-size: 15px;
  vertical-align: top;
  line-height: 10px;
`



// WEBPACK FOOTER //
// ./src/components/RegisteredTrademarkIcon/component.styles.js